export default {"src":"/login-app/[GIT_HASH]/_next/static/media/materialization_started.e0815f39.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};